export const MISSING_ANDROID_TYPE = 'androidType'
export const MISSING_API_KEY = 'apiKey'
export const MISSING_BANNER = 'banner'
export const MISSING_DEV_PERMISSIONS = 'devPermissions'

export const MISSING_TEAM_NAME = 'teamName'
export const MISSING_DD_EMAIL = 'ddEmail'
export const MISSING_EMAIL = 'email'
export const MISSING_PASSWORD = 'password'
export const MISSING_DD_PASSWORD = 'ddPassword'
export const MISSING_TEAM_ID = 'teamId'
export const MISSING_FASTLANE_PASSWORD = 'fastlanePassword'
export const MISSING_DD_FASTLANE_PASSWORD = 'ddFastlanePassword'
export const MISSING_ACCOUNT_TYPE = 'type'
export const MISSING_CREATED_BY = 'createdBy'
export const MISSING_DEV_PROGRAM_REGISTERED_AT = 'developerProgramRegisteredAt'
export const MISSING_CORPORATE_DOCUMENT = 'corporateDocument'
export const MISSING_CORPORATE_NAME = 'corporateName'
export const MISSING_SPLASHSCREEN = 'splashscreenImg'

const androidErrors = [
    MISSING_ANDROID_TYPE,
    MISSING_DEV_PERMISSIONS,
    MISSING_API_KEY,
]

const iOSErrors = [
    MISSING_TEAM_NAME,
    MISSING_EMAIL,
    MISSING_DD_EMAIL,
    MISSING_PASSWORD,
    MISSING_DD_PASSWORD,
    MISSING_TEAM_ID,
    MISSING_FASTLANE_PASSWORD,
    MISSING_DD_FASTLANE_PASSWORD,
    MISSING_ACCOUNT_TYPE,
    MISSING_CREATED_BY,
    MISSING_DEV_PROGRAM_REGISTERED_AT,
    MISSING_CORPORATE_DOCUMENT,
    MISSING_CORPORATE_NAME,
    MISSING_SPLASHSCREEN,
]

export { androidErrors, iOSErrors }
